import Footer from '@/components/common/Footer';
import Sidebar from '@/components/common/Sidebar';
import Header from '@/components/Header';
import Marquee from '@/components/Marquee';
import { useState } from 'react';
import { Outlet, useLocation } from 'react-router-dom';

const MainLayout = () => {
  const [isSidebarOpen, setIsSidebarOpen] = useState(false);
  const location = useLocation();
  const reportsPage = location.pathname.includes('user');
  const dashboardPage = location.pathname.includes('dashboard');
  return (
    <div className="bg-primary">
      <Header onMenuClick={() => setIsSidebarOpen(!isSidebarOpen)} />
      {!reportsPage && <Marquee type="mobile" />}
      <div className="flex xl:mt-1 min-h-[calc(100vh-169px)]">
        <Sidebar isOpen={isSidebarOpen} onToggle={() => setIsSidebarOpen(!isSidebarOpen)} />

        <main className="flex-1 overflow-hidden mb-14 md:mb-0 333">
          <Outlet />
        </main>
      </div>
      {/* Footer */}
      {dashboardPage && <Footer />}
    </div>
  );
};

export default MainLayout;
